module.exports = __webpack_public_path__ + "assets/img/00111.d1930c60.png";